var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendarTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.83317 0.833333C4.37293 0.833333 3.99984 1.20643 3.99984 1.66667V2.5H3.1665C1.78579 2.5 0.666504 3.61929 0.666504 5V16.6667C0.666504 18.0474 1.78579 19.1667 3.1665 19.1667H9.91735C9.42912 18.6882 9.02461 18.1247 8.72786 17.5H3.1665C2.70627 17.5 2.33317 17.1269 2.33317 16.6667V9.16667H15.6665V9.40823C16.2685 9.5874 16.8298 9.86115 17.3332 10.2122V5C17.3332 3.61929 16.2139 2.5 14.8332 2.5H13.9998V1.66667C13.9998 1.20643 13.6267 0.833333 13.1665 0.833333C12.7063 0.833333 12.3332 1.20643 12.3332 1.66667V2.5H5.6665V1.66667C5.6665 1.20643 5.29341 0.833333 4.83317 0.833333ZM12.3332 5V4.16667H5.6665V5C5.6665 5.46024 5.29341 5.83333 4.83317 5.83333C4.37293 5.83333 3.99984 5.46024 3.99984 5V4.16667H3.1665C2.70627 4.16667 2.33317 4.53976 2.33317 5V7.5H15.6665V5C15.6665 4.53976 15.2934 4.16667 14.8332 4.16667H13.9998V5C13.9998 5.46024 13.6267 5.83333 13.1665 5.83333C12.7063 5.83333 12.3332 5.46024 12.3332 5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1665 13.3333C13.1665 12.8731 13.5396 12.5 13.9998 12.5C14.4601 12.5 14.8332 12.8731 14.8332 13.3333V14.7525L15.5666 15.4859C15.892 15.8113 15.892 16.339 15.5666 16.6644C15.2411 16.9898 14.7135 16.9898 14.3881 16.6644L13.4106 15.6869C13.2355 15.5118 13.1546 15.2782 13.1679 15.049C13.167 15.0328 13.1665 15.0164 13.1665 15V13.3333Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9998 15C18.9998 17.7614 16.7613 20 13.9998 20C11.2384 20 8.99984 17.7614 8.99984 15C8.99984 12.2386 11.2384 10 13.9998 10C16.7613 10 18.9998 12.2386 18.9998 15ZM10.6514 15C10.6514 16.8493 12.1506 18.3484 13.9998 18.3484C15.8491 18.3484 17.3482 16.8493 17.3482 15C17.3482 13.1507 15.8491 11.6516 13.9998 11.6516C12.1506 11.6516 10.6514 13.1507 10.6514 15Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarTime);
export default __webpack_public_path__ + "static/media/calendar-time.321a77720e4895a2e8ed5b5ced842e56.svg";
export { ForwardRef as ReactComponent };